/*
 * Define the global awc object if it doesn't exist.
 * It should be used by plugins and themes to communicate with the AWC framework.
 */
if ( ! window.awc ) {
	window.awc = {};
}
